<div class="bio">
  <p>
    Cassettiquette is an indie rock band from Charlotte, NC that blends introspective lyrics with
    dreamy, atmospheric sounds.<br />Consisting of Connor Hausman (lead vocals/guitar), Emma Freas
    (vocals/keys), Trevor Martin (drums), Korey Dudley (bass), and Beau Sigmon (guitar),
    Cassettiquette pulls inspiration from bands like Death Cab for Cutie, The Killers, and
    Radiohead.<br />In 2024, the band was recognized as Charlotte's Best New Band by Queen City
    Nerve. Their music explores a mix of personal and fictional stories with a sound that continues
    to evolve.
  </p>
</div>

<style>
  .bio {
    line-height: 1.8;
    font-size: 1.1rem;
    max-height: 300px;
    overflow-y: auto;
    padding-right: 1rem;
  }
  p {
    margin-bottom: 1rem;
  }
</style>
